import React from 'react';
import { H1 } from 'elements/Typography';

const Profile: React.FC = () => {
  return (
    <div>
      <H1>WIP</H1>
    </div>
  );
};

export default Profile;
